import { createBrowserRouter } from 'react-router-dom'
import type { DIContainer } from '@/di/DIContext'
import { FrameLayout } from '../components/FrameLayout'
import { MainLayout } from '../components/MainLayout'
import { RouteErrorBoundary } from '../components/RouteErrorBoundary'
import { createAuthLoader, createNicknameLoader } from '../loaders'

import ChangePassword from '../pages/ChangePassword'
import EditNickname from '../pages/EditNickname'
import Home from '../pages/Home'
import Invite from '../pages/Invite'
import Login from '../pages/Login'
import Me from '../pages/Me'
import PrivacyPolicy from '../pages/PrivacyPolicy'
import SetNickname from '../pages/SetNickname'
import Team from '../pages/Team'
import TermsAndConditions from '../pages/TermsAndConditions'

/**
 * 创建路由配置
 */
export const createRoutes = (diContainer: DIContainer) => {
  const authLoader = createAuthLoader(diContainer)
  const nicknameLoader = createNicknameLoader(diContainer)

  return [
    {
      element: <FrameLayout />,
      errorElement: <RouteErrorBoundary />,
      children: [
        // 1. 公开页面 (无需登录)
        { path: '/login', element: <Login /> },
        { path: '/terms-and-conditions', element: <TermsAndConditions /> },
        { path: '/privacy-policy', element: <PrivacyPolicy /> },

        // 2. 需登录校验的页面
        {
          loader: authLoader,
          children: [
            // 2a. 仅需登录的页面
            { path: '/set-nickname', element: <SetNickname /> },

            // 2b. 既需登录又需设置昵称的页面
            {
              loader: nicknameLoader,
              children: [
                {
                  element: <MainLayout />,
                  children: [
                    { path: '/', element: <Home /> },
                    { path: '/team', element: <Team /> },
                    { path: '/invite', element: <Invite /> },
                    { path: '/me', element: <Me /> },
                  ],
                },
                { path: '/edit-nickname', element: <EditNickname /> },
                { path: '/change-password', element: <ChangePassword /> },
              ],
            },
          ],
        },
      ],
    },
  ]
}

/**
 * 创建路由对象
 */
export const createRouter = (diContainer: DIContainer) => {
  return createBrowserRouter(createRoutes(diContainer))
}
